export default __webpack_public_path__ + "static/media/100KLS.18839538.webp";